import { Component } from '@angular/core';

@Component({
  selector: 'sbw-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

}
